/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export function Idle(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/idle.glb')
  const { actions } = useAnimations(animations, group)
  useEffect(() => {
  actions['Armature|mixamo.com|Layer0.002'].play();
}); 
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group name="bottom" position={[0, -10, 0]} rotation={[-Math.PI, 0, -Math.PI]} scale={0.01} />
        <group name="Armature" rotation={[Math.PI / 2, 0, 0]} scale={0.01}>
          <primitive object={nodes.mixamorigHips} />
          <skinnedMesh name="Boy01_Body_Geo" geometry={nodes.Boy01_Body_Geo.geometry} material={materials['Boy01_Body_MAT1.003']} skeleton={nodes.Boy01_Body_Geo.skeleton} />
          <skinnedMesh name="Boy01_Brows_Geo" geometry={nodes.Boy01_Brows_Geo.geometry} material={materials['Boy01_Brows_MAT2.003']} skeleton={nodes.Boy01_Brows_Geo.skeleton} />
          <skinnedMesh name="Boy01_Eyes_Geo" geometry={nodes.Boy01_Eyes_Geo.geometry} material={materials['Boy01_Eyes_MAT2.003']} skeleton={nodes.Boy01_Eyes_Geo.skeleton} />
          <skinnedMesh name="h_Geo" geometry={nodes.h_Geo.geometry} material={materials['Boy01_Mouth_MAT2.003']} skeleton={nodes.h_Geo.skeleton} />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/idle.glb')
